import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import Moment from "moment";
import Select from "react-select";
import NumericInput from 'react-numeric-input';
import { apiFetch, API, getMarket } from "../../services/api";


const options = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' }
]

function getCategories(headCategory) {
    let parentCategory = headCategory.split("/products").pop()
    return fetch('https://back-products-api.therunningcollective.fr/categories?headCategory='+parentCategory, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export default class AddAmbassadorRewardModal extends Component {
    constructor(props) {
        super(props);
        this.state ={
            selectedLogo: this.props.selectedReward.logo,
            selectedCover: this.props.selectedReward.cover,
            giftToSend: this.props.selectedReward.giftToSend,
            giftToPhysicalSend: this.props.selectedReward.giftToPhysicalSend,
            uniqueProduct: this.props.selectedReward.uniqueProduct,
            onlyForAmbassador: this.props.selectedReward.onlyForAmbassador,
            isUniqueVoucher: this.props.selectedReward.isUniqueVoucher,
            selectedHeadCategory: this.props.selectedReward.headCategory,
        };
    }

    async componentDidMount() {
        await getCategories(this.props.selectedReward.headCategory).then(data => {
            this.setState({availableCategories: data})
        }).catch(err =>
            this.setState({errors: "error while getting categories"})
        );
    };

    handleClose = () => {
        this.props.selectedReward.giftToSend = this.state.giftToSend
        this.props.selectedReward.giftToPhysicalSend = this.state.giftToPhysicalSend
        this.props.selectedReward.isUniqueVoucher = this.state.isUniqueVoucher
        this.props.selectedReward.onlyForAmbassador = this.state.onlyForAmbassador
        this.props.selectedReward.uniqueProduct = this.state.uniqueProduct
        this.props.selectedReward.language = getMarket()

        apiFetch(API.back + '/ambassador-reward', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.props.selectedReward)
        })
            .then( () => (this.props.closeModal, window.location.reload(false)))
            .catch( err =>
                console.log(err)
            );
    }

    uploadLogo = async (e) => {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            apiFetch(API.back + '/upload-file', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "rewards/"+fileName
                })
            }).then((res) =>
                res.json().then( result =>{
                        sleep(2000)
                        this.props.selectedReward.logo = result.message
                        this.setState({selectedLogo: result.message})
                    }
                )
            )
                .catch( err =>
                    console.log(err)
                );
        }
    }

    uploadCover = async (e) => {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            apiFetch(API.back + '/upload-file', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "rewards/"+fileName
                })
            }).then((res) =>
                res.json().then( result =>{
                        sleep(2000)
                        this.props.selectedReward.cover = result.message
                        this.setState({selectedCover: result.message})
                    }
                )
            )
                .catch( err =>
                    console.log(err)
                );
        }
    }

    requestRegion = (event) => {
        this.props.selectedReward.minimumLevel = event.value
    }

    async changeCategories(headCategory) {
        await getCategories(headCategory).then(data => {
            this.setState({availableCategories: data})
        }).catch(err =>
            this.setState({errors: "error while getting availableCategories"})
        );
    };

    render(){

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une récompense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Nom : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedReward.name = e.target.value} defaultValue={this.props.selectedReward.name} placeholder="Ex : Alltricks"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Logo : </Form.Label>
                                            <Form.File
                                                id="custom-file-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => this.uploadLogo(e)}
                                                custom
                                            />
                                            {this.state.selectedLogo ? <img alt="Logo..." className="imgToDisplay" src={this.state.selectedLogo}/>
                                            :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-file-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => this.uploadCover(e)}
                                                custom
                                            />
                                            {this.state.selectedCover ? <img alt="Logo..." className="imgToDisplay" src={this.state.selectedCover}/>
                                                :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Petite Description : </Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedReward.description = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedReward.description ? this.props.selectedReward.description : this.props.selectedReward.description} placeholder="5 dossards pour les 10km de Paris ..."/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Grosse description : </Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedReward.bigDescription = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedReward.bigDescription ? this.props.selectedReward.bigDescription : this.props.selectedReward.bigDescription} placeholder="5 dossards pour les 10km de Paris ..."/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Est-ce une récompense à envoyer par la poste ? </Form.Label>
                                            <Form.Check aria-label="availableSoon"
                                                        defaultChecked={this.props.selectedReward.giftToPhysicalSend}
                                                        onChange={(e) => this.setState({giftToPhysicalSend: e.target.checked})} />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Sexe :</Form.Label>
                                            <Form.Control
                                                as="select"
                                                multiple
                                                onChange={(e) => this.props.selectedReward.genders = [...e.target.selectedOptions].map(o => o.value)}
                                                defaultValue={this.props.selectedReward.genders}
                                            >
                                                <option value="Men">Homme</option>
                                                <option value="Women">Femme</option>
                                                <option value="Unisex">Unisexe</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Type de produit : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => {this.props.selectedReward.headCategory = e.target.value; this.changeCategories(e.target.value)}}
                                                defaultValue={this.props.selectedReward.headCategory}
                                            >
                                                <option value="...">Ajouter...</option>
                                                <option value="/products/shoes">Chaussures</option>
                                                <option value="/products/spikes">Pointes</option>
                                                <option value="/products/apparel">Vêtements</option>
                                                <option value="/products/accessories">Accessoires</option>
                                                <option value="/products/electronic">Electronique</option>
                                                <option value="/products/nutrition">Nutrition</option>
                                                <option value="/products/vouchers">Carte cadeau</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Est-ce un produit unique? </Form.Label>
                                            <Form.Check aria-label="uniqueProduct"
                                                        defaultChecked={this.props.selectedReward.uniqueProduct}
                                                        onChange={(e) => this.setState({uniqueProduct: e.target.checked})} />
                                        </Form.Group>
                                        {
                                            this.state.availableCategories  && !this.state.uniqueProduct ? 
                                            <Form.Group>
                                                <Form.Label>Catégories</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    multiple
                                                    onChange={(e) => this.props.selectedReward.categories = [...e.target.selectedOptions].map(o => o.value)}
                                                    defaultValue={this.props.selectedReward.categories}
                                                >
                                                    {(this.state.availableCategories) ? this.state.availableCategories.map(category =>
                                                        <option key={category} value={category}>{category}</option>
                                                    ) : <option>Aucunes catégories disponibles</option>}
                                                </Form.Control>
                                            </Form.Group>
                                            : null
                                        }
                                        
                                        <Form.Group>
                                            <Form.Label>Nombre de récompense disponible : </Form.Label>
                                            <Form.Row>
                                                <NumericInput min={1}
                                                              max={100000}
                                                              value={this.props.selectedReward.winnersCount}
                                                              onChange={(value) => this.props.selectedReward.winnersCount = value}/>
                                                </Form.Row>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Prix minimum: </Form.Label>
                                            <Form.Row>
                                            <NumericInput min={1}
                                                          max={100000}
                                                          value={this.props.selectedReward.price}
                                                          onChange={(value) => this.props.selectedReward.price = value}/>
                                            </Form.Row>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Date de début : </Form.Label>
                                            <Form.Control key="beginDate" type="datetime-local" name="begin" placeholder="Début"
                                                          defaultValue={Moment(this.props.selectedReward.beginDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                          onChange={(e) => this.props.selectedReward.beginDate = new Date(e.target.value).toISOString()}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Date de fin : </Form.Label>
                                            <Form.Control key="endDate" type="datetime-local" name="end" placeholder="Fin"
                                                          defaultValue={Moment(this.props.selectedReward.endDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                          onChange={(e) => this.props.selectedReward.endDate = new Date(e.target.value).toISOString()}
                                            />
                                        </Form.Group>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export function sleep(time){
    return new Promise((resolve)=>setTimeout(resolve,time)
    )
}